import {
  Alert,
  Button,
  Group,
  NumberInput,
  Select,
  Stack,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { adminAdjustUserCredits } from "../../api";
import { notifications } from "@mantine/notifications";

export default function UserCreditAdjustForm({ userId }) {
  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      type: "Generic",
      amount: 0,
      note: "",
    },
  });

  return (
    <form
      onSubmit={form.onSubmit((values) => {
        adminAdjustUserCredits({ ...values, userId }).then(() =>
          notifications.show({ title: "Success" })
        );
      })}
    >
      <Stack spacing="sm">
        {/* adminAdjustUserCredits(values) */}
        <Alert title="Adjust Credits">
          This adds or removes credits from the user's account. It doesn't set
          the final amount, just the delta.
        </Alert>

        <Select
          key={form.key("type")}
          {...form.getInputProps("type")}
          data={[
            { label: "Generic", value: "Generic" },
            { label: "Training", value: "Training" },
          ]}
        />
        <NumberInput
          key={form.key("amount")}
          {...form.getInputProps("amount")}
          decimalScale={0}
        />
        <TextInput
          key={form.key("note")}
          {...form.getInputProps("note")}
          placeholder="Note"
        />
        <Group justify="flex-end" mt="md">
          <Button type="submit">Save</Button>
        </Group>
      </Stack>
    </form>
  );
}
